import { useQuery } from "@tanstack/react-query";
import { inboxApi } from "views/inbox/api/api";
import { useInboxToken } from "views/inbox/api/useInboxToken";
import { CONVERSATION_SEARCH_LIMIT, MIN_QUERY_LENGTH } from "./constants";

const CONVERSATION_SEARCH_QUERY_KEY = "MASTER_SEARCH_CONVERSATIONS";

export const useConversationSearch = (query: string, enabled: boolean) => {
  const { accessToken, isError: isTokenError } = useInboxToken();

  const search = useQuery({
    queryKey: [CONVERSATION_SEARCH_QUERY_KEY, query],
    queryFn: ({ signal }) =>
      inboxApi.globalSearch(query, CONVERSATION_SEARCH_LIMIT, signal),
    enabled: enabled && !!accessToken && query.length >= MIN_QUERY_LENGTH,
    staleTime: 30_000,
    retry: false
  });

  return {
    data: search.data,
    isError: search.isError || isTokenError
  };
};
